export var balanceSummary = function balanceSummary(theme) {
  return {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    padding: '1.2em 0',
    borderBottom: "1px solid ".concat(theme.gray100),
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr'
    }
  };
};
export var balanceField = function balanceField(theme) {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.4em',
    padding: '0.6em 1.6em',
    borderRight: "1px solid ".concat(theme.gray100),
    '&:last-of-type': {
      borderRight: 'none'
    },
    '@media (max-width: 600px)': {
      borderRight: 'none',
      borderBottom: "1px solid ".concat(theme.gray100),
      '&:last-of-type': {
        borderBottom: 'none'
      }
    }
  };
};
export var balanceLabel = function balanceLabel(theme) {
  return {
    fontSize: '1.1rem',
    color: theme.gray300
  };
};
export var balanceAmount = function balanceAmount(theme) {
  return {
    fontSize: '1.4rem',
    fontWeight: 600,
    color: theme.gray700,
    fontVariantNumeric: 'tabular-nums'
  };
};